import LinkButton from 'components/shared/button/LinkButton';
import GNEModal from 'components/shared/modal/Modal';
import React, { useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import classes from './SectionMenu.module.scss';
import { buildFilterPayload, getAccessibleFilters } from 'utils/utils';
import { renameInsightView } from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setSaveInsightViewBtnState,
  setSelectedInsightView,
} from 'store/customer/customerViewSlice';
import { toast } from 'react-toastify';
import {
  BUTTON_STATE,
  CONFIGURE_VIEW,
  VIEW_ACTION_TYPE,
} from 'constants/constants';
import AddNewView from 'components/shared/views/add-new-view/AddNewView';

function SaveWarningModal(props) {
  const dispatch = useDispatch();

  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );
  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const AffiliationFilter = useSelector(
    (state) => state?.CustomerView?.affiliationsFilters
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );
  const payerMixFilters = useSelector(
    (state) => state.CustomerView?.payerMixFilters
  );
  const policyDetailsFilters = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters
  );
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );
  const ecosystemOpportunityFilters = useSelector(
    (state) => state.CustomerView?.ecosystemOpportunityFilters
  );

  const [viewModalShow, setViewModalShow] = useState(false);

  const handleCancel = () => {
    props.onHide();
  };

  const handleProceedWithoutSave = () => {
    if (props?.viewActionType === VIEW_ACTION_TYPE.ADD_NEW_VIEW) {
      props?.onProceedWithoutSave();
      setViewModalShow(true);
    } else if (props?.viewActionType === VIEW_ACTION_TYPE.DUPLICATE) {
      props.onProceedWithoutSave();
    } else if (props?.viewActionType === VIEW_ACTION_TYPE.CHANGE_VIEW) {
      props?.onProceed();
    }
  };

  const handleSaveAndProceed = async () => {
    let filters = {
      Engagements: engagementFilters,
      SitePerformance: sitePerformanceFilters,
      SiteUtilization: siteUtilizationFilters,
      Affiliations: AffiliationFilter,
      CopayAnalytics: copayAnalyticsFilters,
      ProductMix: productMixFilters,
      PayerMix: payerMixFilters,
      PolicyDetails: policyDetailsFilters,
      EcosystemOpportunity: ecosystemOpportunityFilters,
    };

    // Get only those filters whose keys are NOT present in componentAccessList
    filters = getAccessibleFilters(filters, componentAccessList, selectedView);

    const payload = {
      id: selectedInsightView?.Id,
      filters: buildFilterPayload(filters),
    };

    await renameInsightView(payload)
      .then(() => {
        const updatedViews = allInsightViews.map((item) => {
          if (item.Id === selectedInsightView?.Id) {
            dispatch(setSelectedInsightView({ ...item, filters: filters }));
            return { ...item, filters: filters };
          }
          return item;
        });
        dispatch(setAllInsightView(updatedViews));
        toast.success('View changes saved successfully');
        if (props?.viewActionType === VIEW_ACTION_TYPE.ADD_NEW_VIEW) {
          props.onSaveViewWarning();
          setViewModalShow(true);
        } else if (props?.viewActionType === VIEW_ACTION_TYPE.DUPLICATE) {
          props.onSaveViewWarning();
        } else if (props?.viewActionType === VIEW_ACTION_TYPE.CHANGE_VIEW) {
          props.onProceed();
        }
        dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const title = (
    <div className='d-flex px-3 pt-2'>
      <i className='icon icon__tile-impact-warning-confirmation mt-1'></i>
      <p className='text text__bold text__base'>Warning - Unsaved Changes</p>
    </div>
  );

  const content = (
    <div className='px-3 pb-3'>
      <span className='text text__small '>
        There are unsaved changes to the insight board view listed below. Would
        you like to save these changes before continuing or proceed without
        saving?
      </span>
      <div className='mt-4 mb-5 '>
        <Form.Group as={Col}>
          <Form.Control
            type='text'
            value={selectedInsightView?.name}
            readOnly
            className={`text text__normal text__bold ${classes['save-view-field']}`}
            tabIndex={-1}
            onMouseDown={(e) => e.preventDefault()}
          />
        </Form.Group>
      </div>
      <div className={`d-flex justify-content-end`}>
        <LinkButton
          className='text text__small me-2'
          onClick={handleCancel}>
          Cancel
        </LinkButton>
        <button
          className={`${classes['discard-btn']} text text__bold px-3`}
          onClick={handleProceedWithoutSave}>
          Proceed without Saving
        </button>
        <Button
          variant='btn btn-gne btn-primary'
          onClick={handleSaveAndProceed}
          className={`text__small ms-3`}>
          Save and Proceed
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <GNEModal
        show={props.show}
        onHide={props.onHide}
        content={content}
        titlecontent={title}
        css={`size-medium`}
      />
      {viewModalShow && (
        <AddNewView
          openModal={viewModalShow}
          onOpenHandler={setViewModalShow}
          page={CONFIGURE_VIEW.insights}
        />
      )}
    </>
  );
}

export default SaveWarningModal;
